import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dab1170"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type"]

import { BarButtonMode, BarButtonType } from './BarButton.interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'BarButton',
  props: {
    type: { default: 'button' },
    mode: { default: 'regular' },
    label: { default: '' }
  },
  setup(__props: any) {

const modeClassMapping: Record<BarButtonMode, string> = {
  regular: 'bar-button--regular',
  outline: 'bar-button--outline'
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["bar-button rounded", [modeClassMapping[_ctx.mode]]]),
    type: _ctx.type
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})